<template>
  <div class="cq-page">
    <template-history :key="routeKey" :api="api" :app-id="appId" @execute="onExecute" @edit="onEdit" />
  </div>
</template>

<script>
import templateHistory from '../views/template-history.vue'
import { getCustomQueryApi, ROUTE_NAMES, PAYLOAD_KEY, openRouteInNewTab } from '../runtime'

export default {
  name: 'custom-query-history-page',
  components: { templateHistory },
  data () {
    return {
      mark: '',
      appId: '',
      api: getCustomQueryApi()
    }
  },
  computed: {
    routeKey () {
      return JSON.stringify(this.$route.query)
    }
  },
  created () {
    this.syncRouteQuery()
  },
  beforeRouteUpdate (to, from, next) {
    this.syncRouteQuery()
    next()
  },
  methods: {
    syncRouteQuery () {
      this.mark = this.$route.query.mark || ''
      this.appId = this.$route.query.appId || ''
    },
    onExecute (row) {
      row = row || {}
      // 历史模板执行：queryJson 取模板的 queryConfig，通过 localStorage 传给新开的结果页
      localStorage.setItem(PAYLOAD_KEY, JSON.stringify({ queryJson: row.queryConfig || '', templateId: row.id, templateName: row.templateName }))
      openRouteInNewTab(this.$router, { name: ROUTE_NAMES.result, query: { mark: this.mark, appId: this.appId, templateId: row.id, templateName: row.templateName } })
    },
    onEdit (row) {
      row = row || {}
      openRouteInNewTab(this.$router, { name: ROUTE_NAMES.config, query: { mark: this.mark, appId: this.appId, templateId: row.id, templateName: row.templateName } })
    }
  }
}
</script>

<style lang="less" scoped>
.cq-page {
  min-height: 100%;
  background: #f0f2f5;
}
</style>



// WEBPACK FOOTER //
// src/component/data-grid/custom-query/pages/history-page.vue